import {React,useEffect} from 'react';
import { motion } from 'framer-motion';
import AboutImage from "../assests/About.png"
import mobile_about from "../assests/mobile_about.png"

const About = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.8,
        staggerChildren: 0.2
      }
    }
  };
    useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" }
    }
  };

  const heroVariants = {
    hidden: { opacity: 0, scale: 0.95 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: { duration: 0.8, ease: "easeOut" }
    }
  };

  const textVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, delay: 0.3 }
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section with Responsive Background Image */}
      <motion.section 
        className="relative h-[500px] flex items-center justify-center overflow-hidden"
        variants={heroVariants}
        initial="hidden"
        animate="visible"
      >
        {/* Background Image Overlay - Responsive using CSS classes */}
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat hero-bg-desktop md:hero-bg-desktop hero-bg-mobile"
          style={{ backgroundColor: '#4a5568' }}
        />
        
        {/* CSS for responsive background images */}
        <style jsx>{`
          .hero-bg-desktop {
            background-image: linear-gradient(135deg, rgba(5, 114, 175, 0.7) 0%, rgba(5, 114, 175, 0.4) 50%, transparent 70%), url('${AboutImage}');
          }
          
          @media (max-width: 767px) {
            .hero-bg-mobile {
              background-image: linear-gradient(135deg, rgba(5, 114, 175, 0.7) 0%, rgba(5, 114, 175, 0.4) 50%, transparent 70%), url('${mobile_about}') !important;
            }
          }
        `}</style>
        
        {/* Content Overlay */}
        <div className="relative z-10 text-center text-white px-4 max-w-4xl mx-auto">
          <motion.h1 
            className="text-4xl md:text-6xl font-bold mb-6"
            variants={textVariants}
            initial="hidden"
            animate="visible"
          >
            WHO WE ARE
          </motion.h1>
          
          <motion.p 
            className="text-lg md:text-xl leading-relaxed max-w-3xl mx-auto"
            variants={textVariants}
            initial="hidden"
            animate="visible"
            transition={{ delay: 0.5 }}
          >
            Established in 1989 in New Delhi, Vidyut Systems has over 35 years of 
            experience delivering reliable power electronics solutions, including 
            lift inverters, solar kits, and UPS systems.
          </motion.p>
        </div>

        {/* Decorative Elements */}
        <motion.div 
          className="absolute bottom-10 right-10 w-16 h-16 border-2 border-white/30 rounded-full hidden md:block"
          animate={{ 
            rotate: 360,
            scale: [1, 1.1, 1]
          }}
          transition={{ 
            rotate: { duration: 20, repeat: Infinity, ease: "linear" },
            scale: { duration: 2, repeat: Infinity }
          }}
        />
        
        <motion.div 
          className="absolute top-20 left-10 w-8 h-8 border-2 border-white/20 rounded-full hidden md:block"
          animate={{ 
            y: [0, -10, 0],
            opacity: [0.5, 1, 0.5]
          }}
          transition={{ 
            duration: 3, 
            repeat: Infinity,
            ease: "easeInOut"
          }}
        />
      </motion.section>

      {/* Content Section with Your Exact Text */}
      <motion.section 
        className="py-16 px-4 max-w-7xl mx-auto"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        viewport={{ once: true }}
      >
        <motion.div 
          className="rounded-2xl p-4 md:p-12"
          variants={itemVariants}
          transition={{ duration: 0.3 }}
        >
          <motion.p 
            className="text-gray-700 text-lg leading-relaxed mb-8"
            variants={itemVariants}
          >
            With over 250 man-years of experience in Power Electronics and DSP systems, Vidyut Systems has been designing and 
            delivering reliable online UPS solutions for mission-critical applications for over two decades.
          </motion.p>
          
          <motion.p 
            className="text-gray-700 text-lg leading-relaxed mb-8"
            variants={itemVariants}
          >
            We now offer this expertise through ready-to-use Power Cards for home UPS and inverters, built with cutting-edge 
            technology and proven long-term performance.
          </motion.p>
          
          <motion.p 
            className="text-gray-700 text-lg leading-relaxed"
            variants={itemVariants}
          >
            Recognizing the challenges of excelling in R&D, manufacturing, and marketing simultaneously, we partner with businesses 
            in an equitable alliance. While we provide advanced R&D and manufacturing capabilities, you focus on branding, 
            marketing, and customer service—creating mutual growth.
          </motion.p>
        </motion.div>
      </motion.section>

      {/* CTA Section */}
      <motion.div 
        className="bg-[#0572AF] py-16 px-4 text-center"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        <motion.div 
          className="max-w-4xl mx-auto"
          variants={itemVariants}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Ready to Power Your Critical Systems?
          </h2>
          <p className="text-blue-100 mb-8 text-lg">
            Contact our team for expert advice, technical support, and to request 
            a quote for the VS3P 72V 6KVA Inverter.
          </p>
          <motion.button 
            className="bg-white text-[#0572AF] px-8 py-3 rounded-lg font-semibold hover:bg-blue-50 transition-colors"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Request a quote
          </motion.button>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default About;